var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2 7.1999C13.2 9.8624 11.0625 11.9999 8.4 11.9999C5.7375 11.9999 3.6 9.8624 3.6 7.1999C3.6 4.5374 5.7375 2.3999 8.4 2.3999C11.0625 2.3999 13.2 4.5374 13.2 7.1999ZM0 20.2874C0 16.7249 2.925 13.7999 6.4875 13.7999H10.3125C13.875 13.7999 16.8 16.7249 16.8 20.2874C16.8 20.9999 16.2 21.5999 15.4875 21.5999H1.3125C0.6 21.5999 0 20.9999 0 20.2874Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0998 9.89971H21.2998V8.09971C21.2998 7.61221 20.8873 7.19971 20.3998 7.19971C19.9123 7.19971 19.4998 7.61221 19.4998 8.09971V9.89971H17.6998C17.2123 9.89971 16.7998 10.3122 16.7998 10.7997C16.7998 11.2872 17.2123 11.6997 17.6998 11.6997H19.4998V13.4997C19.4998 13.9872 19.9123 14.3997 20.3998 14.3997C20.8873 14.3997 21.2998 13.9872 21.2998 13.4997V11.6997H23.0998C23.5873 11.6997 23.9998 11.2872 23.9998 10.7997C23.9998 10.3122 23.5873 9.89971 23.0998 9.89971Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdd);
export default __webpack_public_path__ + "static/media/UserAdd.8faf02baf66efe4f1c39eab131a04556.svg";
export { ForwardRef as ReactComponent };